import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";


import styles from "./Header.module.css";
import Ologo from "../../assets/OGEP LOGO.png";
import Upicon from "../../assets/arrow-circle-broken-up-right.svg";
import { useNavigate } from "react-router-dom";


const Header = () => {
  const location = useLocation();
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const navigate = useNavigate();
  const handleLogin = () => {
    navigate("/login");
  };
  const handleSignUp = () => {
    navigate("/signup");
  };
  const handleHome = () => {
    navigate("/");
  };

  useEffect(() => {
    if (!location.hash) return;

    const id = location.hash.replace("#", "");
    const element = document.getElementById(id);

    if (element) {
      const yOffset = -80;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }, [location]);

  const closeMenu = () => setShowMobileMenu(false);

  return (
    <header className={styles.header} onClick={handleHome}>
      {/* Logo */}
      <div className={styles.logo}>
        <div className={styles.logoIcon}>
          <img src={Ologo} className={styles.imgRe} />
        </div>
        {/* <span>OGIRS</span> */}
      </div>

      {/* ===== DESKTOP NAV (UNCHANGED) ===== */}
      <nav className={styles.nav}>
       
      </nav>

      {/* ===== DESKTOP ACTIONS (UNCHANGED) ===== */}
      <div className={styles.actions}>
       <NavLink
          to="/monthly_reports"
          className={({ isActive }) =>
            isActive ? styles.activeLink : styles.link
          }
        >
         About Us
        </NavLink>

        <NavLink
          to="/monthly_reports"
          className={({ isActive }) =>
            isActive ? styles.activeLink : styles.link
          }
        >
          Who It's For
        </NavLink>

        <NavLink
          to="/open_data"
          className={({ isActive }) =>
            isActive ? styles.activeLink : styles.link
          }
        >
          How it works
        </NavLink>

        
        <button className={styles.loginBtn} onClick={handleLogin}>Login</button>

        <button className={styles.getStartedBtn}
        onClick={handleSignUp}
        >
          Register
          {/* <img src={Upicon} className={styles.btnIcon} /> */}
        </button>
      </div>

      {/* ===== MOBILE HAMBURGER ===== */}
      <button
        className={styles.hamburger}
        onClick={() => setShowMobileMenu(true)}
      >
        ☰
      </button>

      {/* ===== MOBILE OFFCANVAS ===== */}
      <Offcanvas
        show={showMobileMenu}
        onHide={closeMenu}
        placement="end"
        className={styles.mobileOffcanvas}
      >
        <Offcanvas.Header>
          <button className={styles.closeBtn} onClick={closeMenu}>
            ✕
          </button>
        </Offcanvas.Header>

        <Offcanvas.Body className={styles.mobileMenu}>
          <NavLink to="" onClick={closeMenu}>Projects</NavLink>
          <NavLink to="" onClick={closeMenu}>Monthly Reports</NavLink>
          <NavLink to="" onClick={closeMenu}>Open Data</NavLink>
          <NavLink to="" onClick={closeMenu}>Open Document</NavLink>
          <NavLink to="" onClick={closeMenu}>FAQs</NavLink>

          <div className={styles.mobileActions}>
            <button className={styles.loginBtn} 
            onClick={handleLogin}>Login</button>

            <button className={styles.getStartedBtn}
             onClick={handleSignUp}
            >
             Register
              {/* <img src={Upicon} className={styles.btnIcon} /> */}
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </header>
  );
};

export default Header;

